import React from "react";
import { Form, message } from "antd";
import { getProjects } from "../../Projects/Application/Projects.business";
import CustomError from "../../Utils/Domain/CustomError";
import { postSDG } from "../../Projects/Infrastructure/Projects.service";
import "./NewSDG.css";
import Modal from "../../Modal/Modal";
import SdgSelector from "./SgdSelector";
import { ButtonEgreen } from "../../Utils/UI/Text";

const NewSDG = ({ projectId }) => {
  const [form] = Form.useForm();

  async function handleSubmit() {
    const { sdgCode } = form.getFieldsValue();
    try {
      await postSDG(projectId, { code: sdgCode });
      form.resetFields();
      message.success("Se agregó un nuevo SDG");
      return true;
    } catch (error) {
      const customError = new CustomError(error);
      message.error(customError.message);
      return false;
    }
  }

  return (
    <div style={{ padding: '20px' }}>
      <h3>Crear Nuevo SDG</h3>
      <Form
        requiredMark={false}
        layout="vertical"
        onFinish={handleSubmit}
        form={form}
        initialValues={{ sdgCode: null }}
      >
        <SdgSelector />
        <div style={{ marginTop: '20px' }}>
          <ButtonEgreen text="Guardar SDG" onClick={handleSubmit} />
        </div>
      </Form>
    </div>
  );
};

export default NewSDG;
